import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import { CLIENT_VIEWS } from '@nile/components';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import InlineText from '@nile/components/src/Components/InlineEdit/Components/InlineText';
import { isEmpty } from 'lodash';

const Wrapper = styled.div`
  .inline-edit--readview:hover {
    ${(props) => props.editable && `background: #ffffff !important;`}
  }
`;

function EditableCell(props) {
  const { cell, intl, data } = props;
  const meta = cell?.row?.original;
  const { actions, field, view } = cell.column;
  const value = meta[field.name];
  const [edit, setEdit] = useState(false);
  const handleChange = (val) => {
    actions.updateData(meta, field.name, val);
  };

  const getEditPermission = () => {
    if (view === CLIENT_VIEWS.invoiceAudit) return cell?.column?.isEditable;
    return (
      cell?.column?.isEditable &&
      !(
        meta.adjustedBlockHour ||
        meta.adjustedBlockMoney ||
        meta.eligibleBlockHour ||
        meta.eligibleBlockMoney
      )
    );
  };
  const isEditable = getEditPermission();

  return (
    <Wrapper editable={isEditable} className="fx">
      <InlineText
        editMode={edit}
        setEditState={setEdit}
        multiline
        variant={`subdued ${isEmpty(value) ? 'opacity5' : ''}`}
        actionClass={isEditable && 'action-button'}
        wrapperClassname={isEditable && 'editable-cell'}
        defaultValue={value}
        saveValue={(val, cb) => {
          if (val !== value) {
            actions.updateAudit(meta, field.name, val, cb);
          } else {
            if (cb) cb('');
            setEdit(false);
          }
        }}
        saveOnEnter
        editable={isEditable}
        input="number"
        type={cell.column.id === 'revisedUnitPrice' ? 'currency' : undefined}
      />
    </Wrapper>
  );
}

export default injectIntl(EditableCell);
